import apiCall from '@/utils/apiCall';
import router from '@/router/';

export default {
    /**
     * Logout user
     *
     * @param    {object}   state           Vuex state.
     * @param   {Function}  state.commit    Commit mutation.
     */
    async logOut({ commit }) {
        await apiCall(this._vm, 'post', '/api/user/logout');

        commit('resetState');
        router.push('/login').catch(() => {});
    },

    /**
     * Handle user logout if session expired.``
     *
     * @param    {object}   state           Vuex state.
     * @param   {Function}  state.commit    Commit mutation.
     */
    handleExpiredLogin({ commit }) {
        commit('resetState');
        commit('setLoginRedirectUrl', router.currentRoute.path);
        router.push('/login').catch(() => {});
    },

    /**
     * Loads user data from API
     *
     * @param    {object}   state           Vuex state.
     * @param   {Function}  state.commit    Commit mutation.
     *
     */
    async loadUser({ commit, state }) {
        if (state.user) {
            return;
        }

        const response = await apiCall(this._vm, 'get', '/api/user');
        const { data, status } = response;

        if (200 === status) {
            commit('setUser', data);
        }
    },

    /**
     * Get user data from API
     *
     * @param    {object}   state           Vuex state.
     * @param   {Function}  state.commit    Commit mutation.
     *
     */
    async updateUser({ commit }) {
        const response = await apiCall(this._vm, 'get', '/api/user');
        const { data, status } = response;

        if (200 === status) {
            commit('setUser', data);
            return true;
        }
    },

    /**
     * Sets new avatar url
     *
     * @param   {object}  {state}  Vuex state.
     * @param   {string}  payload  New avatar url.
     */
    setNewAvatar({ commit }, payload) {
        commit('newAvatar', payload);
    },

    /**
     * Sets user meta
     *
     * @param   {object}   params        Params.
     * @param   {Function} params.commit Commit mutation.
     * @param   {Function} params.state  Vuex state.
     * @param   {object}   meta          User meta.
     *
     */
    async setUserMeta({ commit, state }, meta) {
        const response = await apiCall(this._vm, 'put', '/api/user/meta', meta);

        if (200 === response.status && response.data) {
            commit('replaceUserMeta', {
                ...state.user.meta_data,
                ...meta,
            });
        }
    },

    /**
     * Sets user meta
     *
     * @param   {object}   params        Params.
     * @param   {Function} params.commit Commit mutation.
     * @param   {Function} params.state  Vuex state.
     * @param   {object}   meta          ser meta.
     *
     */
    async deleteUserMeta({ commit, state }, meta) {
        const response = await apiCall(this._vm, 'delete', '/api/user/meta', { data: meta });

        if (200 === response.status) {
            const newMeta = { ...state.user.meta_data };

            for (const item of meta) {
                delete newMeta[item];
            }

            commit('replaceUserMeta', newMeta);
        }
    },

    /**
     * Updates user beta access status.
     *
     * @param   {object}   options        Vuex store.
     * @param   {Function} options.commit Commit mutation.
     * @param   {Function} options.state  Vuex state.
     * @param   {boolean}  betaAccess     Beta access status.
     */
    async updateUserBetaAccess({ commit, state }, betaAccess) {
        if (state.user.beta_participant === betaAccess) {
            return;
        }

        const { data } = await apiCall(this._vm, 'put', '/api/user/beta', { beta: betaAccess });

        commit('setUser', data);
    },
};
